export default function TrustSection() {
  const riskItems = [
    {
      icon: 'ri-links-line',
      title: 'Fake Spreadsheet Links',
      desc: 'Always verify that you are accessing the official OOPBuy spreadsheet through verified channels and trusted sources only.',
      risk: 'Medium',
      protection: 'Verified sources only',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Payment Security',
      desc: 'All transactions are processed through the secure checkout system with encryption and proper verification protocols in place.',
      risk: 'Low',
      protection: 'Secure checkout system',
    },
    {
      icon: 'ri-truck-line',
      title: 'Shipping Transparency',
      desc: 'Real-time tracking updates are provided for every order. Delays can happen with international shipping, but you will always know the status.',
      risk: 'Medium',
      protection: 'Tracking updates provided',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Order Documentation',
      desc: 'Every order creates a documented record within the spreadsheet system, giving you a clear paper trail for reference and dispute resolution.',
      risk: 'Low',
      protection: 'Full order records',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Agent Verification',
      desc: 'Agents operating within the OOPBuy system follow standardized procedures with quality checks at multiple stages of the process.',
      risk: 'Low',
      protection: 'Standardized procedures',
    },
    {
      icon: 'ri-global-line',
      title: 'International Compliance',
      desc: 'The system follows international shipping and commerce guidelines to ensure smooth cross-border transactions for all buyers.',
      risk: 'Medium',
      protection: 'Compliance monitoring',
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200/50 text-secondary-800 text-xs font-semibold mb-8">
            / Trust &amp; Safety
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-[1.1] max-w-3xl">
            Is OOPBuy<br />Spreadsheet Safe?
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mt-6 leading-relaxed">
            The OOPBuy Spreadsheet system uses structured order tracking, verified payment processes, and standardized agent workflows to ensure a secure and transparent shopping experience. Below is a breakdown of potential risks and how the system protects you.
          </p>
        </div>

        {/* Risk Cards - Masonry-like 3 column */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {riskItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-50 border border-background-200/60 p-7 flex flex-col"
            >
              {/* Header */}
              <div className="flex items-start gap-4 mb-5">
                <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-lg text-accent-700`}></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-foreground-950">{item.title}</h4>
                  <span className="text-xs text-foreground-500">Risk Level: {item.risk}</span>
                </div>
              </div>

              {/* Body */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 flex-1">
                &ldquo;{item.desc}&rdquo;
              </p>

              {/* Footer */}
              <div className="flex items-center gap-2 pt-4 border-t border-background-200">
                <i className="ri-shield-flash-line text-accent-600 text-sm"></i>
                <span className="text-xs font-semibold text-accent-700">{item.protection}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="mt-14 p-6 rounded-2xl bg-background-200/50 border border-background-300/50">
          <p className="text-xs text-foreground-500 leading-relaxed text-center max-w-2xl mx-auto">
            <strong className="text-foreground-700">Disclaimer:</strong> This is an informational and educational platform about the OOPBuy spreadsheet shopping system. We are not a direct payment processor. All transactions occur through the main platform at kaspreadsheet.com. Users should always verify spreadsheet sources before placing orders.
          </p>
        </div>
      </div>
    </section>
  );
}